import { useSelector } from 'react-redux';

import { aiContentFields } from '../../components/pages/contentOptimizer/contentPage/content/briefTab/contentBriefsConstants';
import {
    selectAIContentLoadingField,
    selectAIContentLoadingProgress,
} from '../../components/pages/contentOptimizer/contentPage/content/briefTab/content/tabsContent/store/contentBriefsOutline.selectors';

export const useIsAIContentGeneration = () => {
    const aiContentLoadingField = useSelector(selectAIContentLoadingField);
    const aiContentLoadingProgress = useSelector(selectAIContentLoadingProgress);
    const isAIContentGeneration = aiContentLoadingField === aiContentFields.OPTIMIZER;
    const isAIContentLoading = Boolean(aiContentLoadingField);

    return {
        isAIContentGeneration,
        isAIContentLoading,
        aiContentLoadingField,
        aiContentLoadingProgress,
    };
};
